import { useCallback } from 'react';

export default function LavoraConNoiCardShared({
  icon: Icon,
  title = '',
  text,
  // esistente
  showButton = false,
  buttonLabel = 'GUARDA IL VIDEO',
  onOpenVideo, // funzione del padre che apre la modale/player
  videoSrc, // singolo video (primario)
  ariaControls = 'header-video-modal',
  // NUOVI props (opzionali) — link secondario
  secondaryHref, // se presente, mostra il "bottone" link
  secondaryButtonLabel = 'VAI AL LINK',
  secondaryTarget = '_blank',
  secondaryRel = 'noopener noreferrer'
}) {
  const handleClickPrimary = useCallback(() => {
    if (typeof onOpenVideo === 'function') {
      onOpenVideo(videoSrc);
    } else if (videoSrc) {
      window.open(videoSrc, '_blank', 'noopener,noreferrer');
    }
  }, [onOpenVideo, videoSrc]);

  const showSecondary = Boolean(secondaryHref);

  return (
    <div
      className="snf-lx-components-lavora-con-noi-rework-cardshared-cardshared"
      style={{ display: 'contents' }}
    >
      <>
        <div className="wrapper">
          <div className="row m-0 justify-content-center">
            <div className="col-auto mb-3">{Icon}</div>
          </div>

          {title ? (
            <div className="row m-0 justify-content-center text-center">
              <div className="col-auto snf-font-w6 snf-font-18 mb-3">{title}</div>
            </div>
          ) : null}

          <div className="row m-0 justify-content-center text-center">
            <div className="col-auto snf-font-16 mb-3">{text}</div>
          </div>

          {(showButton || onOpenVideo || videoSrc) && (
            <div className="row m-0 justify-content-center mt-auto">
              <div className="col-auto">
                {showSecondary ? (
                  // BOTTONE VIDEO + "BOTTONE" LINK (ancora stilizzata)
                  <div
                    className="d-flex flex-wrap"
                    style={{ gap: '0.5rem', justifyContent: 'center' }}
                  >
                    <button
                      type="button"
                      className="btn btn-cta rounded-0 snf-bg-color-denim text-white px-3 snf-font-12 text-uppercase snf-font-w6"
                      onClick={handleClickPrimary}
                      aria-haspopup={onOpenVideo ? 'dialog' : undefined}
                      aria-controls={onOpenVideo ? ariaControls : undefined}
                    >
                      {buttonLabel}
                    </button>

                    <a
                      href={secondaryHref}
                      target={secondaryTarget}
                      rel={secondaryRel}
                      className="btn btn-cta rounded-0 snf-bg-color-denim text-white px-3 snf-font-12 text-uppercase snf-font-w6"
                      role="button"
                    >
                      {secondaryButtonLabel}
                    </a>
                  </div>
                ) : (
                  // SOLO BOTTONE VIDEO (comportamento esistente)
                  <button
                    type="button"
                    className="btn btn-cta rounded-0 snf-bg-color-denim text-white px-3 snf-font-12 text-uppercase snf-font-w6"
                    onClick={handleClickPrimary}
                    aria-haspopup={onOpenVideo ? 'dialog' : undefined}
                    aria-controls={onOpenVideo ? ariaControls : undefined}
                  >
                    {buttonLabel}
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      </>
    </div>
  );
}
